import { StyledGrid, StyledTooltip } from 'styles/common';

import { StyledTableCell, StyledTextField } from './styles';

export const TagDescription = ({ description, handleKeyDown, handleOnChange, isEditing, isRenaming }) => (
  // return useMemo( () => {
  <StyledTableCell paddingtop="0" paddingBottom="0" border>
    <StyledTooltip title={isEditing || isRenaming ? '' : description}>
      <div>
        {(isEditing || isRenaming || description) && (
          <StyledTextField
            disabled={!isEditing && !isRenaming}
            color="theme.palette.grey.dark"
            placeholder="Description"
            name="description"
            fullWidth
            margin="none"
            variant="outlined"
            value={description || ''}
            onKeyDown={handleKeyDown}
            onChange={handleOnChange}
            style={{ height: '40px', justifyContent: 'center' }}
            $truncateText={!isEditing && !isRenaming}
          />
        )}
        {!isEditing && !isRenaming && !description && <StyledGrid container style={{ marginLeft: '1rem' }} />}
      </div>
    </StyledTooltip>
  </StyledTableCell>
);
